import { render, staticRenderFns } from "./ScheduledPickups.vue?vue&type=template&id=58ab157d&"
import script from "./ScheduledPickups.vue?vue&type=script&lang=js&"
export * from "./ScheduledPickups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports